/**
 * Vital Vail — sensor sync
 *
 * Single source of truth for "which sensor is active".
 * Reads from URL ?sensor=, falls back to default on chip row.
 * Updates chips, URL, and dispatches 'vv:sensor-change' for grids to react.
 *
 * Each VV grid section listens for this event and re-renders its tiles
 * by finding the variant whose option1 matches the sensor label.
 */

(function () {
  const SENSOR_MAP = {
    g7: 'Dexcom G7 / One+',
    g6: 'Dexcom G6 / One',
    l2: 'Libre 2 / 2+',
    l3: 'Libre 3 / 3+',
  };

  const VALID_CODES = Object.keys(SENSOR_MAP);

  function getSensorFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const s = params.get('sensor');
    return s && VALID_CODES.includes(s) ? s : null;
  }

  function setUrl(code) {
    const url = new URL(window.location.href);
    url.searchParams.set('sensor', code);
    window.history.replaceState({}, '', url);
  }

  function setActiveChip(code) {
    document.querySelectorAll('[data-vv-chip]').forEach((btn) => {
      btn.dataset.active = btn.dataset.vvChip === code ? 'true' : 'false';
    });
  }

  function broadcast(code) {
    const label = SENSOR_MAP[code];
    window.VV_ACTIVE_SENSOR = { code, label };
    window.dispatchEvent(
      new CustomEvent('vv:sensor-change', { detail: { code, label } })
    );
  }

  function setSensor(code) {
    if (!VALID_CODES.includes(code)) return;
    setUrl(code);
    setActiveChip(code);
    broadcast(code);
  }

  // Boot
  document.addEventListener('DOMContentLoaded', () => {
    const chipRow = document.querySelector('[data-vv-chips]');
    if (!chipRow) return;

    const fromUrl = getSensorFromUrl();
    const fallback = chipRow.dataset.defaultSensor || 'g7';
    const initial = fromUrl || fallback;

    setSensor(initial);

    chipRow.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vv-chip]');
      if (!btn) return;
      setSensor(btn.dataset.vvChip);
    });
  });

  // Expose for manual triggers if needed
  window.VV = { setSensor, SENSOR_MAP };
})();
